import React, { FunctionComponent } from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { NavLink } from "react-router-dom";
import { HeaderChild, SubHeaderChild } from "interfaces/header/HeaderInterfaces";

type Props = {
  child: HeaderChild;
  subItems: SubHeaderChild[];
  dropEnd?: boolean; // true en desktop
};

const SubMenuGroupItem: FunctionComponent<Props> = ({ child, subItems, dropEnd = true }) => (
  <UncontrolledDropdown className={`dropdown-submenu ${dropEnd ? "dropend" : ""}`} inNavbar>
    <DropdownToggle
      caret={false}
      tag="div"
      className="submenu-toggle dropdown-item d-flex align-items-center justify-content-between p-4 submenu-row"
    >
      <span className="flex-grow-1">{child.label}</span>
      <span className="submenu-caret mt-1" aria-hidden />
    </DropdownToggle>

    <DropdownMenu className="m-0">
      {subItems.map((sub, idx) => (
        <DropdownItem key={idx} className="menu-item px-4 py-3 submenu-row">
          {sub.link ? <NavLink to={sub.link}>{sub.label}</NavLink> : <span className="text-muted">{sub.label}</span>}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default SubMenuGroupItem;
